import { FC, useState } from 'react';

import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CloseIcon from '@mui/icons-material/Close';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';

import styles from './matter-news.module.css';

const isBrowser = typeof window !== 'undefined';

export const ShareNews: FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const rawUrl = isBrowser ? window.location.href : '';
  const rawTitle = isBrowser ? document.title || 'Notícia' : 'Notícia';
  const shareUrl = encodeURIComponent(rawUrl);
  const title = encodeURIComponent(rawTitle);

  const emailLink = `mailto:?subject=${title}&body=${shareUrl}`;
  const whatsappLink = `https://api.whatsapp.com/send?text=${title}%20${shareUrl}`;

  const openPopup = (link: string) => {
    if (isBrowser) window.open(link, '_blank', 'noopener,noreferrer');
  };

  const copyLink = () => {
    if (!isBrowser || !navigator.clipboard) return;
      navigator.clipboard
        .writeText(rawUrl)
        .then(() => alert('Link copiado para a área de transferência!'))
        .catch(() => alert('Não foi possível copiar o link.'));
  };

  let isMobile = false;
  if (isBrowser) {
    const ua = navigator.userAgent;
    const isMobileUa =
        /Android|iPhone|iPad|iPod|Mobile/i.test(ua) && !/Macintosh/i.test(ua);
    const isCoarse =
      window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    isMobile = isMobileUa || isCoarse;
  }

  const handleShareClick = async () => {
    if (isBrowser && isMobile && (navigator as any).share) {
      try {
        await (navigator as any).share({ title: rawTitle, url: rawUrl });
        return; 
      } catch {
        return; 
      }
    }
    if (isBrowser) setIsOpen(true); 
  };

  const closeModal = () => setIsOpen(false);

  return (
    <>
      <button className={styles.shareButton} onClick={handleShareClick}>
        <ShareOutlinedIcon className={styles.shareButtonIcon} />
        <span>Compartilhar</span>
      </button>

      {isBrowser && isOpen && (
        <div className={styles.shareModalOverlay}>
          <div className={styles.shareModal}>
            <div className={styles.shareModalHeader}>
                <div className={styles.headerBar} />
                <span className={styles.headerTitle}>
                    Escolha onde deseja compartilhar a notícia.
                </span>
                <button
                    className={styles.shareModalClose}
                    onClick={closeModal}
                    aria-label="Fechar"
                >
                    <CloseIcon fontSize="medium" />
                </button>
            </div>

            <div className={styles.shareModalText}>
                Clique no ícone da rede social ou app.
            </div>

            <div className={styles.shareIconList}>
              <a
                className={styles.shareIconWrapper}
                href={emailLink}
                title="Email"
              >
                <EmailIcon className={styles.shareIcon} />
              </a>

              <button
                type="button"
                className={styles.shareIconWrapper}
                onClick={() => openPopup(whatsappLink)}
                title="WhatsApp"
              >
                <WhatsAppIcon className={styles.shareIcon} />
              </button>

              <button
                type="button"
                className={styles.shareIconWrapper}
                onClick={copyLink}
                title="Copiar link"
              >
                <FacebookIcon className={styles.shareIcon} />
              </button>

              <button
                type="button"
                className={styles.shareIconWrapper}
                onClick={copyLink}
                title="Copiar link"
              >
                <InstagramIcon className={styles.shareIcon} />
              </button>

              <button
                type="button"
                className={styles.shareIconWrapper}
                onClick={copyLink}
                title="Copiar link"
              >
                <LinkedInIcon className={styles.shareIcon} />
              </button>
            </div>

            <div className={styles.shareModalFooter}>
              <button
                className={styles.shareModalCloseButton}
                onClick={closeModal}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};